import axios from 'axios'

function transkeyDataType(props) {
    const id0 = props.id0
    const id1 = props.id1
    window.mtk.fillEncData()
    return {
        id: id0,
        transkeyPwd: document.getElementById('transkey_' + id0).value,
        transkeyHM: document.getElementById('transkey_HM_' + id0).value,
        keyboardType: document.getElementById('keyboardType_' + id0).value,
        keyIndex: document.getElementById('keyIndex_' + id0).value,
        fieldType: document.getElementById('fieldType_' + id0).value,
        seedKey: document.getElementById('seedKey').value,
        initTime: document.getElementById('initTime').value,
    }
}
function decodeTest(props) {
    axios
        .post(
            '/uib/mao/prd/withoutSessionDecode',
            JSON.stringify(transkeyDataType(props)),
            {
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        )
        .then((res) => {
            alert(res.data)
        })
}
function DecodeButtonComponent({ props }) {
    return (
        <>
            <button
                onClick={() => {
                    decodeTest(props)
                }}
            >
                Match Test
            </button>
        </>
    )
}

export default DecodeButtonComponent
